/** @format */

import Layout from '../Partials/Layout';
import { Link, useLocation, useHistory } from 'react-router-dom';
import api from '../../shared/utils/auth/Index';
import { useState, useEffect } from 'react';
import Loader from '../../shared/components/Loader';
import Pagination from '../../shared/components/Pagination';
import useQueryString from '../../shared/utils/queryString';

const List = () => {
	const { search } = useLocation();

	const history = useHistory();

	const [orders, setOrders] = useState(undefined);
	useEffect(() => {
		fetchOrders();
	}, [search]);

	const [filters, setFilters] = useState({});
	const handleFilter = (e) => {
		e.preventDefault();
		let queryString = useQueryString.createQueryStr(search, {
			page: 1,
			...filters,
		});

		history.push({
			search: queryString,
		});

		// setProducts(undefined);
	};

	const fetchOrders = () => {
		let url = '/order' + search;
		api.get(
			url,
			{},
			(res) => {
				let data = res.data;
				setOrders(data);
			},
			(err) => {
				alert('error');
			},
		);
	};

	const onDelete = (id) => {
		id = parseInt(id);

		if (window.confirm('آیا مطمئن هستید؟')) {
			setOrders({
				...orders,
				data: orders.data.filter((cat) => cat.id !== id),
			});

			deleteItem(id);
		}
	};

	const deleteItem = (id) => {
		let url = `/order/${id}`;

		api.delete(
			url,
			{},
			(res) => {},
			(err) => {
				alert('Error: Item has not deleted');
			},
		);
	};

	if (orders === undefined)
		return (
			<Layout>
				<Loader />
			</Layout>
		);

	return (
		<Layout>
			<div className='font-irs-b'>
				<h4 className='d-inline-block ml-4'>داشبورد</h4>
			</div>
			<hr className='my-1 bold-hr' />

			<form onSubmit={(e) => handleFilter(e)}>
				<div className='row py-2'>
					<div className='col-auto'>
						<input
							type='text'
							value={filters.name}
							onChange={(e) => setFilters({ ...filters, name: e.target.value })}
							className='form-control'
						/>
					</div>
					<div className='col-auto'>
						<button type='submit' className='btn btn-outline-primary'>
							جستجو
						</button>
					</div>
					{/*<div className='col-auto'>
						<Link to='/order/show/print' className='btn btn-info'>
							چاپ سفارشات
						</Link>
	</div>*/}
				</div>
			</form>

			<div className='row'>
				<div className='col-12'>
					<table className='table table-striped custom-table'>
						<thead>
							<tr>
								<th>#</th>
								<th>نام و نام خانوادگی</th>
								<th>نام تحویل گیرنده</th>
								<th>تلفن تحویل گیرنده</th>
								<th>کد پستی تحویل گیرنده</th>
								<th>وضعیت</th>
								<th>مشاهده</th>
							</tr>
						</thead>
						<tbody>
							{orders.data.map((order, index) => (
								<tr key={order.id}>
									<td>{index + 1}</td>
									<td>
										{order?.user?.name} {order?.user?.surname}
									</td>
									<td>
										{order.name} {order.surname}
									</td>
									<td>{order.phone}</td>
									<td>{order.zip_code}</td>
									<td>
										{order.paid_status == 1 ? (
											<span className='badge badge-success badge-pill p-2'>
												موفق
											</span>
										) : (
											<span className='badge badge-danger badge-pill p-2'>
												ناموفق
											</span>
										)}
									</td>
									<td>
										<Link to={`order/${order.id}`} className='btn btn-link'>
											مشاهده
										</Link>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>

			<div className='row'>
				<div className='col-12'>
					<Pagination meta={orders.meta} states={filters} />
				</div>
			</div>
		</Layout>
	);
};

export default List;
